/*

  # Navigation using a dropdownlist (select element)
  
  - Add data-hook="dropdownlistNavigation" to any select element
  - Values of the option elements are the navigation URLs
  
*/

 import {
  assignController
} from '../api/element-manipulation'

assignController('dropdownlistNavigation', (element) => {
  const go = () => {
    if ( element.value !== '' ) {
      window.location.assign(element.value)
    }
  }
  element.addEventListener('input', go)
})
